import { useCallback, useEffect, useState } from "react";

import { AreaListPanelKey } from "~/modules/plannerV2/constants/areaListPanelConfig";

export function useAreaListPanelToggle(defaultPanel: AreaListPanelKey | null = null) {
    const [openPanel, setOpenPanel] = useState<AreaListPanelKey | null>(defaultPanel);

    useEffect(() => {
        setOpenPanel(defaultPanel);
    }, [defaultPanel]);

    const togglePanel = useCallback((panel: AreaListPanelKey) => {
        setOpenPanel(prevOpenPanel => {
            if (prevOpenPanel === panel) return null;
            return panel;
        });
    }, []);

    return {
        openPanel,
        togglePanel,
        isPanelOpen: (panel: AreaListPanelKey) => openPanel === panel,
    };
}
